import { atom } from 'recoil'

export const isOpenLogoutState = atom({
  key: 'isOpenLogoutState',
  default: false
})
